<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('weekdayType.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('weekdayType.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
          ></div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>
            {{ record.weekday_type }}
          </td>
          <td class="text-center">
            <a-popconfirm
              placement="leftTop"
              :title="$t('user.are_you_sure_to_update')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @cancel="
                record.is_required_study_time = !record.is_required_study_time
              "
              @confirm="onUpdate(record)"
            >
              <a-switch
                :loading="waiting"
                v-model="record.is_required_study_time"
                size="small"
              />
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'weekday-type-table',
  data() {
    return {
      loading: false,
      waiting: false,
      columns: [
        { name: this.$t('weekdayType.weekdayType') },
        {
          name: this.$t('weekdayType.isRequiredStudyTime'),
          style: 'text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('weekdayType', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.weekdayType.search
      },
      set(newValue) {
        this.$store.commit('weekdayType/SET_SEARCH', newValue)
        this.$store.commit('weekdayType/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('weekdayType/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async onUpdate (record) {
      this.waiting = true
      this.$store
        .dispatch('weekdayType/update', {
          id: record.id,
          is_required_study_time: record.is_required_study_time
        })
        .then(async response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetchData()
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
